<template>
  <v-card v-if="landownerType" id="landowner-type-form">
    <v-card-title class="primary white--text">
      <v-row class="pa-2" justify="space-between">
        <span class="headline">
          {{ title }}
        </span>
        <BaseDialogActions hideRefresh hideFullscreen />
      </v-row>
    </v-card-title>
    <v-card-text class="text-right">
      <v-text-field
      class="py-6"
      v-model="landownerType.name"
      :rules="[rules.required]"
      :label="$t('name')"
      color="black"
      :counter="maxNameLength"
      :maxlength="maxNameLength"
      ref="landownerTypeName"/>
      <v-btn id="landowner-type-submit" color="primary" @click="submitClicked" :disabled="!canSubmit">
        {{ buttonText }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { cloneDeep } from 'lodash'
import fieldRules from '@/utils/rules.js'
import { StringConstants } from '@/utils/constants'

export default {
  name: 'LandownerTypeForm',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    propLandownerType: {
      type: Object,
      required: false,
      default: undefined
    }
  },

  created () {
    if (this.propLandownerType) {
      this.landownerType = cloneDeep(this.propLandownerType)
    }
  },

  mounted () {
    setTimeout(_ => {
      this.$refs.landownerTypeName.focus()
      document.addEventListener('keyup', this.onKeyup)
    }, 0)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.onKeyup)
  },

  computed: {
    editing () {
      return this.landownerType?.landownerTypeId
    },

    title () {
      return this.editing ? this.$t('editLandownerType') : this.$t('createNewLandownerType')
    },

    buttonText () {
      return this.editing ? this.$t('saveChanges') : this.$t('create')
    },

    canSubmit () {
      return this.landownerType.name.length > 0 && this.landownerType.name.length <= this.maxNameLength
    }
  },

  data: () => ({
    landownerType: {
      name: ''
    },
    maxNameLength: StringConstants.MediumStringLength,
    rules: fieldRules.rules
  }),

  methods: {
    ...mapActions('tract', ['createLandownerType', 'updateLandownerType']),

    async submitClicked () {
      if (this.canSubmit) {
        this.editing ? await this.updateLandownerType(this.landownerType) : await this.createLandownerType(this.landownerType)
        this.$emit('landowner-type-mutated')
      } else {
        this.setSnackError(this.$t('nameIsRequired'))
      }
    },

    onKeyup (e) {
      if (e.key.toLowerCase() === 'enter') {
        this.submitClicked()
      }
    }
  }
}
</script>
